var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplyEnquire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13337",
    "data-name": "Group 13337",
    transform: "translate(-334 -4957)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(334 4957)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13077",
    "data-name": "Group 13077",
    transform: "translate(350 4972.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    d: "M17.407,34.814A17.407,17.407,0,1,1,34.814,17.407,17.426,17.426,0,0,1,17.407,34.814Zm0-32.639A15.231,15.231,0,1,0,32.639,17.407,15.248,15.248,0,0,0,17.407,2.176Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    d: "M152.474,182.258a1.08,1.08,0,0,1-.769-.319l-4.714-4.714a1.088,1.088,0,1,1,1.539-1.539l3.945,3.946,8.66-8.66a1.088,1.088,0,0,1,1.539,1.539l-9.429,9.429a1.09,1.09,0,0,1-.772.319Zm0,0",
    transform: "translate(-136.699 -159.049)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyEnquire);
export default __webpack_public_path__ + "static/media/apply -enquire.7af8601ba2472b82be7bb50a9ef12a9d.svg";
export { ForwardRef as ReactComponent };